<header class="flex header p-2">
  <h2>{{ 'Production_Card_Move_To_Batch_ReAddFromGreige' | translateWF: 'Add from Greige to Batching' }}</h2>
</header>

<section class="content">
  <p class="mb-3 text-sm text-gray-600">
    {{ 'Production_Card_Move_To_Batch_SelectRollsToAdd' | translateWF: 'Select rolls to add from Greige to Batching. All available rolls in Greige are shown.' }}
  </p>

  <!-- Use another Work Order -->
  <div class="mb-3">
    <div class="flex items-center gap-2 mb-2">
      <p-checkbox [binary]="true" [ngModel]="reAddUseOtherWorkOrder()" (ngModelChange)="reAddUseOtherWorkOrder.set($event)" />
      <label>{{ 'Production_Card_Move_To_Batch_UseOtherWorkOrder' | translateWF: 'Use another Work Order' }}</label>
    </div>
    @if (reAddUseOtherWorkOrder()) {
      <p-autoComplete
        [dropdown]="true"
        #workOrderSearch="cslServerSearch"
        [cslServerSearch]="fetchReAddWorkOrders"
        [suggestions]="workOrderSearch.results()"
        (onSelect)="onReAddWorkOrderSelect($event)"
        optionLabel="orderNumber"
        styleClass="w-full"
        placeholder="{{ 'Production_Card_Move_To_Batch_SearchWorkOrder' | translateWF: 'Search work order...' }}"
      />
    }
  </div>

  <!-- Filter by roll number -->
  <div class="mb-3">
    <label for="reAddRollFilter" class="block text-sm font-medium mb-2">
      {{ 'Production_Card_Move_To_Batch_FilterByRollNumber' | translateWF: 'Filter by Roll Number' }}
    </label>
    <p-autoComplete
      id="reAddRollFilter"
      [ngModel]="reAddRollFilter()"
      (ngModelChange)="reAddRollFilter.set($event)"
      [dropdown]="false"
      [suggestions]="[]"
      placeholder="{{ 'Production_Card_Move_To_Batch_SearchRollNumber' | translateWF: 'Search roll number...' }}"
      styleClass="w-full"
    />
  </div>

  <p-table
    [value]="filteredEligibleRollsFromGreige()"
    [loading]="isLoading() > 0"
    [selection]="selectedRollsToReAdd()"
    (selectionChange)="selectedRollsToReAdd.set($event)"
    dataKey="number"
    [scrollable]="true"
    scrollHeight="400px"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox />
        </th>
        <th>{{ 'Production_Card_Move_To_Batch_RollNumber' | translateWF: 'Roll Number' }}</th>
        <th>{{ 'Production_Card_Move_To_Batch_FabricCode' | translateWF: 'Fabric Code' }}</th>
        <th>{{ 'Production_Card_Move_To_Batch_ItemCode' | translateWF: 'Item Code' }}</th>
        <th>{{ 'Production_Card_Move_To_Batch_WeightLb' | translateWF: 'Weight (lb)' }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-roll>
      <tr>
        <td>
          <p-tableCheckbox [value]="roll" />
        </td>
        <td>{{ roll.number }}</td>
        <td>{{ roll.expectedFabricCode }}</td>
        <td>{{ roll.itemCode }}</td>
        <td>{{ roll.stationTimeStamps?.[roll.stationTimeStamps.length - 1]?.weightInLbs | number: '1.0-2' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center py-4">
          {{ 'Production_Card_Move_To_Batch_NoEligibleRolls' | translateWF: 'No rolls available to add from Greige' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

<footer>
  <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (onClick)="onCancel()" [disabled]="isLoading() > 0" />
  <p-button
    [label]="'Production_Card_Move_To_Batch_AddSelected' | translateWF: 'Add Selected'"
    icon="pi pi-replay"
    severity="success"
    [disabled]="selectedRollsToReAdd().length === 0 || isLoading() > 0"
    [loading]="isLoading() > 0"
    (onClick)="onAddSelected()"
  />
</footer>
